<template>
	<div class="cart">
		<div class="container">
			<div class="row">
				<div class="col-12 p-md-0">
					<div class="col-12 d-flex pl-0 pr-0 pt-5 overflow-md-auto">
						<div class="col col-md-4 p-0 d-flex background-status-cart">
							<div class="col-12 p-0 rounded-left color-white mt-auto mb-auto" >
								<div class="text-center mt-auto font-size-16 font-size-sm-11">Keranjang Belanja</div>
							</div>
							<div class="triangle-active"></div>
						</div>
						<div class="col col-md-5 col-lg-4 p-0 d-flex" :class=" step >= 2 ? 'background-status-cart' : 'background-gray' ">
							<div class="col-12 p-md-0 pr-0 color-white mt-auto mb-auto">
								<div class="text-center font-size-16 font-size-sm-11">Metode Pengiriman</div>
							</div>
							<div class="" :class=" step >= 2 ? 'triangle-active' : 'triangle-off' "></div>
						</div>
						<div class="col col-md-4 p-0 d-flex">
							<div class="col-11 p-0 color-white" :class=" step >= 3 ? 'background-status-cart' : 'background-gray' ">
								<div class="text-center pl-4 pl-md-0 pt-4 pt-md-3 font-size-16 font-size-sm-11">Pembayaran</div>
							</div>
							<div class="" :class=" step >= 3 ? 'triangle-active' : 'triangle-off' "></div>
						</div>
					</div>
					<div class="col-12 p-3 mt-4 background-white cus-box-shadow rounded color-black" v-if="!cart && step == 1">
						<div class="col-8 offset-2 col-md-3 offset-md-0 m-auto text-center">
							<img class="img-fluid" src="assets/icon/ilus-keranjang-kosong.svg" alt="">
						</div>
						<div class="col-12 text-center font-size-14 font-size-sm-12 font-weight-bold pt-2">
							Wah, keranjang belanjamu masih kosong nih...
						</div>
						<div class="col-12 text-center pt-2 font-size-sm-10">
							Yuk, mulai belanja Produk Milagros sekarang juga untuk mendapatkan penawaran terbaik dari kami.
						</div>
						<div class="col-12 text-center pt-3">
							<router-link :to="{name: 'home'}" class="col-9 col-md-5 col-lg-3 btn background-button-template rounded color-white pt-2 pb-2 box-purple">
								<i class="fas fa-shopping-cart mr-3"></i>
								<span class="font-size-12 font-size-sm-10">Belanja Sekarang</span>
							</router-link>
						</div>
					</div>
						<ListProduct :publicData="publicData" v-show="step==1"></ListProduct>
						<shipping-method :shipMethod="shipMethod" :courier="courier" :pickup="pickup" :publicData="publicData" v-if="step==2"></shipping-method>
						<PaymentMethod :shipMethod="shipMethod" :courier="courier" :pickup="pickup" :publicData="publicData" v-if="step>=3"></PaymentMethod>
					
					<last-seen class="mt-4"></last-seen>
					<ml-partner-us></ml-partner-us>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import ListProduct from '../public/ListProduct.vue';
import ShippingMethod from '../public/ShippingMethod.vue';
import LastSeen from '@/components/LastSeen';
import MlPartnerUs from '@/components/MlPartnerUs.vue';
import PaymentMethod from '../public/PaymentMethod.vue';
import { mapState, mapGetters, mapMutations, mapActions } from 'vuex'

export default {
	name: 'cart',
	components: {
		ListProduct, ShippingMethod, PaymentMethod, LastSeen, MlPartnerUs
	},
	data () {
		return {
			shipMethod: {name:"Pilih Metode Pengiriman", code:''},
			publicData: {
				nama: '',
				email: '',
				phone: '',
				sponsor: '',
				ktpNumber: '',
			},
			pickup:{
				date:''
			},
			courier: {
				nama: '',
				phone: '',
				prov: '',
				city: '',
				district: '',
				kodepos: '',
				detail: '',
				status: false
			},
			iscart: true,
			isshipping: true,
		}
	},
	computed: {
		...mapState('cart', ['cart', 'step']),
		...mapGetters('auth', ['isAuth'])
	},
	methods: {
		...mapActions('auth', ['logout']),
		...mapMutations('auth', ['updateAuth']),
		...mapMutations('cart' , ['step_up', 'step_down', 'resetStep']),
		...mapActions('cart', ['checkCart']),

		statusLogin() {
			if(!this.isAuth){
				this.$refs.modalLogin.modalShow()
			} else {
				this.step_up()
			}
		},
		statusHide() {
			this.$refs.modalLogin.modalHide()
		},
		statusUmum() {
			this.$refs.modalUmum.modalShow()
		},
		asPublic() {
			this.umumHide();
			this.step_up()
		},
		umumHide() {
			this.$refs.modalUmum.modalHide()
		},
		statusMitra() {
			this.$refs.modalMitra.modalShow()
		},
		mitraHide() {
			this.$refs.modalMitra.modalHide()
		},
	},
	created: function () {
		this.resetStep()
		this.$store.dispatch('setPageTitle', 'Cart');
	},
	beforeDestroy() {
		window.removeEventListener('scroll', this.handleScroll);
	},
	mounted() {
		this.checkCart()
	},
	filters: {
		truncate: function (text, length, suffix) {
			return text.substring(0, length) + suffix;
		},
	}
}
</script>

<style>
.img-login {
	left: 2rem;
	margin-top: 9px;
	-webkit-filter: grayscale(100%) brightness(110%) contrast(0.9);
	filter: grayscale(100%) brightness(110%) contrast(0.9);
	z-index: 100;
}
</style>